import React from 'react';
import { useTranslation } from 'react-i18next';

export const AboutUs = () => {
  const { t } = useTranslation();
  
  return (
    <section className="about-us">
      <div className="about-header">
        <img src="/images/about-team.jpg" alt="Notre équipe" className="about-image" />
        <h1>{t('aboutUs.title')}</h1>
      </div>
      
      <div className="about-section">
        <h2>{t('aboutUs.expertiseTitle')}</h2>
        <p>{t('aboutUs.expertiseText1')}</p>
        <p>{t('aboutUs.expertiseText2')}</p>
      </div>
      
      <div className="team-section">
        <h2>{t('aboutUs.teamTitle')}</h2>
      </div>
    </section>
  );
};
